module.exports = __webpack_public_path__ + "static/media/SBI-Logo.20b55745.svg";